import { Component, OnInit, Inject, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FormGroup, FormBuilder, Validators, FormControl, FormArray, ValidatorFn } from '@angular/forms';
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from '@angular/material/chips';

import { AngularEditorConfig } from '@kolkov/angular-editor';


@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit {

  dataToShow: any;
    editorContent!: string;
    sendTo: string = '';

    editorConfig: AngularEditorConfig = {
          editable: true,
          spellcheck: true,
          height: 'auto',
          minHeight: '0',
          maxHeight: 'auto',
          width: 'auto',
          minWidth: '0',
          translate: 'yes',
          enableToolbar: true,
          showToolbar: true,
          placeholder: 'Enter text here...',
          defaultParagraphSeparator: '',
          defaultFontName: 'Arial',
          defaultFontSize: '12',
          fonts: [
            {class: 'arial', name: 'Arial'},
            {class: 'times-new-roman', name: 'Times New Roman'},
            {class: 'calibri', name: 'Calibri'},
            {class: 'comic-sans-ms', name: 'Comic Sans MS'}
          ],
    };

    /*-----------------------------------------------------------------------*/
    emailListForm :any= FormGroup;
    submitted = false;

    emailForm!: FormGroup;
    disableSendEmailBtn = true;

    visible = true;
    removable = true;
    addOnBlur = true;
    email_list: string[] = [];
    readonly separatorKeysCodes = [ENTER, COMMA] as const;
    selectable = true;

    @Output() response: EventEmitter<boolean> = new EventEmitter();
    emailInputControl: any;

  constructor(
    public dialogRef: MatDialogRef<EditorComponent>,
    private formBuilder: FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.hasOwnProperty("dataToShow")) {
      this.editorContent = this.data.dataToShow; // Set initial content
    }
    this.previewEmailForm({ emails: this.data.emails, emailContent: this.editorContent ,emailSubject:this.data.subject});
  }

  ngOnInit(): void { }
    
  onClose(): void {
    this.dialogRef.close({ confirm: false });
    this.response = new EventEmitter();
  }

  decline() {
    this.dialogRef.close({ confirm: false });
  }

// sendEmail(emailListForm: FormGroup): boolean {
//   this.submitted = true;

//   if (emailListForm.invalid) {
//     return false;
//   }

//   if (window.confirm('Are you sure you want to send this email?')) {
//     this.dialogRef.close({
//       confirm: true,
//       updatedData: JSON.stringify(emailListForm.value.emailContent),
//       emails: emailListForm.value.emails,
//       emailSubject: emailListForm.value.emailSubject,
//     });
//     return true;
//   } else {
//     this.decline();  // This does not return anything, so we must add:
//     return false;
//   }
// }

  sendEmail(emailListForm: FormGroup) {
    this.submitted = true;

    if (emailListForm.invalid) {
      return ;
    }

    if (window.confirm('Are you sure you want to send this email?')) {
      this.dialogRef.close({ confirm: true, updatedData: JSON.stringify(emailListForm.value.emailContent), emails: emailListForm.value.emails, emailSubject: emailListForm.value.emailSubject });
    } else {
      this.decline();
    }
  }

  addEmail(event: any): void {
    console.log(event,"event")
    const input = event.input;


    const value = event.value?.trim();

    if (value && this.validateEmail(value)) {
      console.log(value,"veluueuue")
      this.email_list.push(value);
      this.emailListForm.get("emails")?.setValue(this.email_list)
    }

    if (input) {
      input.value = '';
    }
  }

  //   addEmail(event: MatChipInputEvent): void {
  //   const input = event.input;
  //   const value = event.value?.trim();

  //   if (value && this.validateEmail(value)) {
  //     this.email_list.push(value);
  //     this.emailListForm.get("emails")?.setValue(this.email_list);
  //   }

  //   if (input) {
  //     input.value = '';
  //   }
  // }
removeEmail(email: string): void {
    const index = this.email_list.indexOf(email);
    if (index >= 0) {
      this.email_list.splice(index, 1);
      this.emailListForm.get("emails")?.setValue(this.email_list);
    }
  }


  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  splitIfComma(value:any) {
    if (!value) return [];
    return value.includes(',') ? value.split(',') : [value];
  }

  private previewEmailForm(values: any) {
    this.email_list = this.splitIfComma(values.emails);
    this.emailListForm = this.formBuilder.group({
      emails: [values.emails ? values.emails : null, Validators.required],
      emailContent: [values.emailContent ? values.emailContent : '', Validators.required],
      emailSubject: [values.emailSubject ? values.emailSubject : "Publish game report", Validators.required]
    })
  }

}
